import { Link } from '@inertiajs/react';
import { ReactNode } from 'react';
import { Trans } from 'react-i18next';

import { useLocale } from '../../Shared/locale';
import { Charity, Event } from '../../Shared/types';
import Layout from '../UI/Layout';

export interface PopularEventsSectionProps {
  events: Event[];
  charity?: Charity | null;
}

export default function PopularEventsSection({
  events,
  charity,
}: PopularEventsSectionProps) {
  const { locale, formatCurrency } = useLocale();

  const getOverviewUrl = (event: { slug: string; }) => {
    return `/${locale}/fundraisers/${charity?.slug || 'all'}/${event.slug}`;
  };

  return (
    <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-2 sm:gap-4">
      {events.map((event) => (
        <Link
          href={getOverviewUrl(event)}
          className="flex items-center p-3 sm:p-4 min-w-0 bg-slate-50 rounded-xl"
          key={event.id}
        >
          <div className="rounded-full w-12 h-12 p-1 bg-white mr-43 shrink-0 shadow-xs mr-3">
            <img src={event.logo_url || ''} alt={event.title} className="object-contain w-full h-full rounded-full" />
          </div>
          <div className="text-slate-500 min-w-0">
            <h3 className="font-medium overflow-hidden whitespace-nowrap text-ellipsis">
              {event.title}
            </h3>
            <div className="text-sm">
              <Trans
                i18nKey="frontend:progress_raised"
                values={{ amount: formatCurrency(event.funds_raised) }}
              >
                <span />
              </Trans>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}

PopularEventsSection.layout = (page: ReactNode) => <Layout>{page}</Layout>;
